export default __webpack_public_path__ + "static/casinolabbet-listar-nyaste-casino-904fba60c284fa0c5f7e9d67e059b751.jpg";